<script>
	import formBase from '@_system/components/base/form.vue'
	export default {
		extends: formBase,
		name: 'goodsprofitForm',
		props: {

		},
		data() {
			return {
				tableaddhandle: null,
				exportData: [],
				loading: false
			}

		},

		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			// 		tablefieldChange(e) {
			// e.data.row.profit_lock = true
			// 		},
			tableAdd(e) {
				// console.log(e)
				this.tableaddhandle = e
				if(e.moduleName == 'goodsprofit_goods'){
					this.$prompt('请输入商品SPU编码', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					}).then(({
						value
					}) => {
						this.$api.goodsprofit.getgoodsspu({
							goodsspu:value
						}).then((res)=>{
							this.tableaddhandle.obj = {
								goodsid:res.goodsUid,
								goodsspu:res.goodsCode,
								goodsname:res.goodsName
							}
							this.tableaddhandle.next()
						})
					}).catch(() => {
						this.tableaddhandle.next()
					});
				}else{
					this.tableaddhandle.next()
				}

			},
		},
		components: {

		}
	}
</script>